import { useProjectTreeStore } from 'store/projectContract.store';
import { useQueryGetSubProgramPreferenceProgressScurve } from 'api/queries/getPrefferedSPIMethod.query';
import { useQueryGetSubProgramPreferencePartialCompletion } from 'api/queries/getSubProgramPreferencePartialCompletion.query';
import { useMemo } from 'react';

import {
    getDecodedValue,
    getEncodeValue,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/programProgressOverview.utils';

export const useProgressMeasurement = () => {
    const { contract } = useProjectTreeStore();
    const { data: progressMeasurementDefaultValue, refetch: refetchProgressMeasurement } =
        useQueryGetSubProgramPreferenceProgressScurve({
            subProgramId: contract?.id,
        });

    const { data: partialCompletionCreditDefaultValue, refetch: refetchPartialCompletionCredit } =
        useQueryGetSubProgramPreferencePartialCompletion({
            subProgramId: contract?.id,
        });

    const value = useMemo(() => {
        return progressMeasurementDefaultValue && partialCompletionCreditDefaultValue
            ? getEncodeValue(progressMeasurementDefaultValue, partialCompletionCreditDefaultValue)
            : undefined;
    }, [progressMeasurementDefaultValue, partialCompletionCreditDefaultValue]);

    const decodedValue = useMemo(() => {
        return value ? getDecodedValue(value) : undefined;
    }, [value]);

    const refetch = () => {
        Promise.all([refetchProgressMeasurement(), refetchPartialCompletionCredit()]);
    };

    return { value, decodedValue, refetch };
};
